import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';

export const BatchProgress = ({ fileQueue, currentQueueIndex, isSecondPass }) => {
  const { t } = useLanguage();
  return (
    <div className="flex items-center gap-2 mt-1">
      <div className="flex gap-1">
        {fileQueue.map((_, i) => (
          <div
            key={i}
            className="h-1.5 rounded-full transition-all"
            style={{
              width: i === currentQueueIndex ? '24px' : '8px',
              backgroundColor: i < currentQueueIndex ? 'hsl(143, 50%, 45%)' :
                i === currentQueueIndex ? 'hsl(143, 28%, 25%)' : 'hsl(143, 28%, 85%)'
            }}
          />
        ))}
      </div>
      <span className="text-xs" style={{ color: 'hsl(125, 12%, 32%)' }} data-testid="batch-progress">
        {(t('plantXOfY') || 'Plant {current} of {total}').replace('{current}', currentQueueIndex + 1).replace('{total}', fileQueue.length)}{isSecondPass ? ` ${t('skippedLabel')}` : ''}
      </span>
    </div>
  );
};
